import spinModel from "../../model/SpinModel";
import { ICondition } from "../State";
import { OverlayType } from "../../server/data/ISpinData";

export default class HasLockedCondition implements ICondition {
    public check(): boolean {
        return spinModel.hasOverlay(OverlayType.Locked);
    }
}